import { render, staticRenderFns } from "./CreateTournament.vue?vue&type=template&id=6c241f54&"
import script from "./CreateTournament.vue?vue&type=script&lang=js&"
export * from "./CreateTournament.vue?vue&type=script&lang=js&"
import style0 from "./CreateTournament.vue?vue&type=style&index=0&id=6c241f54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports